/**
 * Error module.
 * @module video/Error
 */

import './style.css';
import tmpl from './main.ejs';
import Events from 'f.core.event';

/**
 * 播放失败提示
 */
class ErrorBox {
    /**
     * Creates an instance of ErrorBox.
     */
    constructor() {
        // this.title = title || '主...主播失联...搜寻中！';
        this.init();
    }

    /**
     * 初始化
     */
    init() {
        this.initDom();
        this.initEvent();
    }

    /**
     * 初始化dom
     */
    initDom() {
        this.el = $(tmpl())[0];
        this.replay = $(this.el).find('#js_videofail_replay');
    }

    /**
     * 初始化自定义事件
     */
    initEvent() {
        const _this = this;
        this.replay.on('click', () => {
            _this.trigger('replay');
        })
    }

    /**
     * 隐藏组件
     */
    hide() {
        this.el.style.display = 'none';
    }

    /**
     * 显示组件
     */
    show() {
        this.el.style.display = 'block';
    }

    /**
     * 渲染组件
     *
     * @param {HTMLELEMENT} parentNode
     */
    renderTo(parentNode) {
        parentNode.appendChild(this.el);
    }

    /**
     * 销毁组件
     */
    destory() {
        this.el.parentNode.removeChild(this.el);
    }
}

Events.mixTo(ErrorBox);
export default ErrorBox;



// WEBPACK FOOTER //
// ./components/f.component.video.pc/app/modules/error/index.js